export const LABELS = {
  DIALOG_TITLE: 'Selecione a data de ativação',
  SUBMIT_BUTTON: 'Agendar ativação',
  CLOSE_BUTTON: 'Cancelar'
};

export default { LABELS };
